import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_ReminderAlertSetup } from "../shared/data.service";
import { StationReminderAlertSelectRequest } from "../shared/StationReminderAlertSelectRequest";
import { ScanReminderAddComponent } from "./scan-reminder-add/scan-reminder-add.component";
import { ScanReminderCopyComponent } from "./scan-reminder-copy/scan-reminder-copy.component";
import { ScanReminderEditComponent } from "./scan-reminder-edit/scan-reminder-edit.component";
import * as moment from "moment";

@Component({
	selector: "caass-scan-reminder-table",
	templateUrl: "./scan-reminder-table.component.html",
	styleUrls: ["./scan-reminder-table.component.css"],
})
export class ScanReminderTableComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private ReminderAlertService: DataService_ReminderAlertSetup,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@ViewChild("mydt") mydt: Table;

	@Output() Selected: EventEmitter<any> = new EventEmitter();

	subscription: any;

	School: any;

	RangeOption: string = "All";

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	ToggleText: string = "Deactivate Reminder";

	ShowInfo: boolean = false;

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedStationReminderAlert: any;
	lstStationReminderAlert: any = [];

	//Filter lists
	lstAlertTypeDesc: any = [];
	lstPriorityDesc: any = [];
	lstActiveDesc: any = [];

	lstEntryModeDesc: any = [];
	lstExitModeDesc: any = [];
	lstMealModeDesc: any = [];
	lstAccessModeDesc: any = [];
	lstTimeStampModeDesc: any = [];
	lstEventEntryModeDesc: any = [];
	lstEventExitModeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'Message', header: 'Message' },
		// { field: 'AlertTypeDesc', header: 'Type' },
		// { field: 'StartDateDesc', header: 'Start Date' },
		// { field: 'EndDateDesc', header: 'End Date' },
		{ field: "SoundFile", header: "Sound File" },
		{ field: "PersonCount", header: "Person Count" },
		{ field: "c_dateDesc", header: "Created" },
		{ field: "PriorityDesc", header: "Priority" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	ModeCols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "EntryMode", header: "Entry Mode" },
		{ field: "ExitMode", header: "Exit Mode" },
		{ field: "MealMode", header: "Meal Mode" },
		{ field: "AccessMode", header: "Access Mode" },
		{ field: "TimeStampMode", header: "Time Stamp Mode" },
		{ field: "EventEntryMode", header: "Event Entry Mode" },
		{ field: "EventExitMode", header: "Event Exit Mode" },
		{ field: "ParentPortalSendNotification", header: "Notify Parents" },
		{ field: "StudentPortalSendNotification", header: "Notify Student" },
		{ field: "StaffPortalSendNotification", header: "Notify Staff" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadStationReminderAlert() {
		if (this.School == undefined || this.School.SchoolID == undefined) {
			return;
		}

		var fsDate: string = "";
		var feDate: string = "";

		if (this.RangeOption == "Date") {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");

			if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
				return;
			}
		}

		this.loading = true;

		var parms: StationReminderAlertSelectRequest = {
			SchoolID: this.School.SchoolID,
			Active: 2, //All
			StartDate: fsDate,
			EndDate: feDate,
		};

		var result = this.ReminderAlertService.StationReminderAlertInfoSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstStationReminderAlert = response;

				//Load Data Filter Lists
				this.lstAlertTypeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.AlertTypeDesc))).sort();
				this.lstPriorityDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.PriorityDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.ActiveDesc))).sort();

				this.lstEntryModeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.EntryModeDesc))).sort();
				this.lstExitModeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.ExitModeDesc))).sort();
				this.lstMealModeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.MealModeDesc))).sort();
				this.lstAccessModeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.AccessModeDesc))).sort();
				this.lstTimeStampModeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.TimeStampModeDesc))).sort();
				this.lstEventEntryModeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.EventEntryModeDesc))).sort();
				this.lstEventExitModeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.EventExitModeDesc))).sort();

				this.UpdateFilters();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadStationReminderAlert();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ScanReminderAddComponent, {
			header: "Add Reminder",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.School.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadStationReminderAlert();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedStationReminderAlert == null) {
			this.errorMessage = "Select a reminder to edit";
			return;
		}

		var ref = this.dialogService.open(ScanReminderEditComponent, {
			header: "Edit Reminder",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				// SelectedStationReminderAlert: this.SelectedStationReminderAlert
				StationReminderAlertID: this.SelectedStationReminderAlert.StationReminderAlertID,
				ScanExists: this.SelectedStationReminderAlert.ScanExists,
				SchoolID: this.SelectedStationReminderAlert.SchoolID,
				MessageFontColor: this.SelectedStationReminderAlert.MessageFontColor,
				Message: this.SelectedStationReminderAlert.Message,
				AlertType: this.SelectedStationReminderAlert.AlertType,
				StartDate: this.SelectedStationReminderAlert.StartDate,
				EndDate: this.SelectedStationReminderAlert.EndDate,
				Priority: this.SelectedStationReminderAlert.Priority,
				EntryMode: this.SelectedStationReminderAlert.EntryMode,
				ExitMode: this.SelectedStationReminderAlert.ExitMode,
				MealMode: this.SelectedStationReminderAlert.MealMode,
				AccessMode: this.SelectedStationReminderAlert.AccessMode,
				TimeStampMode: this.SelectedStationReminderAlert.TimeStampMode,
				EventEntryMode: this.SelectedStationReminderAlert.EventEntryMode,
				EventExitMode: this.SelectedStationReminderAlert.EventExitMode,
				SoundLibraryID: this.SelectedStationReminderAlert.SoundLibraryID,
				StudentCount: this.SelectedStationReminderAlert.StudentCount,
				ParentPortalSendNotification: this.SelectedStationReminderAlert.ParentPortalSendNotification,
				StudentPortalSendNotification: this.SelectedStationReminderAlert.StudentPortalSendNotification,
				StaffPortalSendNotification: this.SelectedStationReminderAlert.StaffPortalSendNotification,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadStationReminderAlert();
			}
		});
	}

	onCopy() {
		this.errorMessage = "";

		if (this.SelectedStationReminderAlert == null) {
			this.errorMessage = "Select a reminder to copy";
			return;
		}

		var ref = this.dialogService.open(ScanReminderCopyComponent, {
			header: "Copy Reminder",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedStationReminderAlert: this.SelectedStationReminderAlert,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadStationReminderAlert();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedStationReminderAlert == null) {
			this.errorMessage = "Select a reminder to activate or deactivate";
			return;
		}

		var changeTo = this.SelectedStationReminderAlert.Active == true ? 0 : 1;

		//Call SP
		var result = this.ReminderAlertService.StationReminderAlertToggle(this.SelectedStationReminderAlert.StationReminderAlertID, changeTo);
		result.subscribe(
			(response: any) => {
				if (response.Status == true) {
					this.onRowUnselect(null);
					this.loadStationReminderAlert();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "reminder",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not toggle the reminder",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedStationReminderAlert == null) {
			this.errorMessage = "Select a reminder to delete";
			return;
		}

		this.confirmationService.confirm({
			key: "reminderconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				'You are about to delete the reminder "' +
				this.SelectedStationReminderAlert.Message +
				'" that has ' +
				this.SelectedStationReminderAlert.PersonCount +
				" " +
				(this.SelectedStationReminderAlert.PersonCount == 1 ? "person" : "people") +
				" assigned to it. Do you want to continue?",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
		});
	}

	FinishDelete() {
		//Call SP
		var result = this.ReminderAlertService.StationReminderAlertDelete(this.SelectedStationReminderAlert.StationReminderAlertID);
		result.subscribe(
			(response: any) => {
				if (response.Status == true) {
					this.onRowUnselect(null);
					this.loadStationReminderAlert();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "reminder",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the reminder",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onToggleInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;

		this.onRowUnselect(null);

		this.loadStationReminderAlert();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedStationReminderAlert = val.data;

		this.ToggleText = "Deactivate Reminder";
		if (this.SelectedStationReminderAlert.Active == false) {
			this.ToggleText = "Activate Reminder";
		}

		this.Selected.emit(this.SelectedStationReminderAlert);
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		this.SelectedStationReminderAlert = null;

		this.ToggleText = "Deactivate Reminder";

		this.Selected.emit(null);
	}
	onRowDblClick(StationReminderAlert) {
		this.errorMessage = "";
		this.SelectedStationReminderAlert = StationReminderAlert;

		this.ToggleText = "Deactivate Reminder";
		if (this.SelectedStationReminderAlert.Active == false) {
			this.ToggleText = "Activate Reminder";
		}

		this.Selected.emit(this.SelectedStationReminderAlert);
		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	UpdateFilters() {
		this.mydt.filters.ActiveDesc["value"] = "Active"; // Default To 'Active'
	}
	////////////////////////////////////////////
}
